import React, { useEffect, useState, useRef } from 'react';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { ICareersFilterProps } from '../CareerCardGroup';

export interface IDashboardFilter extends ICareersFilterProps {
	tooltip?: string;
}

export interface IDashboardFiltersI18n {
	heading: string;
	resetAllFilters: string;
	filters: IDashboardFilter[];
}

export interface IDashboardFiltersProps {
	i18n?: IDashboardFiltersI18n;
	onChange?: (e: React.SyntheticEvent) => {};
	onClear?: () => {};
	state?: any;
}

const DashboardFilters: React.FC<IDashboardFiltersProps> = ({
	i18n = {
		heading: 'Filters',
		resetAllFilters: 'Reset all filters',
		filters: [
			{
				label: 'Application Status',
				taxonomy: 'application',
				tooltip: 'Here is the application status tooltip',
				options: [
					{
						label: 'Application started',
						value: 'quickApplicationSubmitted',
					},
					{
						label: 'Full application received',
						value: 'fullApplicationSubmitted',
					},
				],
			},
			{
				label: 'Job status',
				taxonomy: 'status',
				tooltip: 'Here is the job status tooltip',
				options: [
					{
						label: 'Open',
						value: 'publish',
					},
					{
						label: 'Closed',
						value: 'closed',
					},
				],
			},
		],
	} as IDashboardFiltersI18n,
	onChange = (e: React.SyntheticEvent) => {},
	onClear = () => {},
	state = {},
}) => {
	const ref = useRef(null);

	useEffect(() => {
		if (!ref.current) {
			return;
		}

		const tooltipTriggerList = ref.current.querySelectorAll(
			'[data-bs-toggle="tooltip"]',
		);
		const tooltipList = [...tooltipTriggerList].map(
			(tooltipTriggerEl) => new Tooltip(tooltipTriggerEl),
		);
	}, []);
	return (
		<div
			className="calian-career-dashboard-filter pt-3 pb-3 p-sm-3 px-lg-2 py-lg-5"
			ref={ref}
		>
			<div className="calian-career-dashboard-filter__desktop d-none d-lg-block">
				<h3 className="h4 ms-lg-4">{i18n.heading}</h3>
				<div
					id="calian-career-dashboard-filter__accordion"
					className="calian-accordion accordion accordion-flush"
				>
					{i18n.filters.map((filter, index) => {
						return (
							<div
								className="accordion-item bg-transparent"
								key={filter.taxonomy}
							>
								<h2
									className="accordion-header"
									id={`heading${index}`}
								>
									<button
										className="accordion-button collapsed bg-transparent ps-lg-4 fw-normal"
										type="button"
										data-bs-toggle="collapse"
										data-bs-target={`#collapse${index}`}
										aria-expanded="false"
										aria-controls={`collapse${index}`}
									>
										{filter.tooltip && (
											<span
												className="d-inline-flex justify-content-start align-items-center"
												data-bs-toggle="tooltip"
												data-bs-custom-class="calian-career-dashboard-filter__tooltip"
												data-bs-placement="top"
												data-bs-title={filter.tooltip}
											>
												{filter.label}
												<i className="icon icon-question btn d-inline-flex justify-content-center align-items-center fs-8 ms-1 p-0"></i>
											</span>
										)}
									</button>
								</h2>
								<div
									id={`collapse${index}`}
									className="accordion-collapse collapse"
									aria-labelledby={`heading${index}`}
								>
									<div className="accordion-body px-4 py-0">
										{(filter.options || []).map(
											(option) => {
												return (
													<div
														key={option.value}
														className="form-check"
													>
														<label
															className="form-check-label fs-7"
															style={{
																cursor: 'pointer',
															}}
															htmlFor={`filter-option-${filter.taxonomy}-${option.value}-checkbox`}
														>
															<input
																className="form-check-input"
																id={`filter-option-${filter.taxonomy}-${option.value}-checkbox`}
																type="checkbox"
																name={`${filter.taxonomy}[]`}
																value={
																	option.value
																}
																checked={
																	(
																		state[
																			filter
																				.taxonomy
																		] || []
																	).indexOf(
																		option.value,
																	) !== -1
																}
																onChange={
																	onChange
																}
															/>
															{option.label}
														</label>
													</div>
												);
											},
										)}
									</div>
								</div>
							</div>
						);
					})}
				</div>

				{Object.entries(state).length > 0 && (
					<button
						className="btn btn-sm link-accent-3 d-flex justify-content-center align-items-center p-0 mt-3 ms-5 fw-normal ls-0"
						onClick={onClear}
					>
						<i className="icon icon-close fs-8px me-2"></i>{' '}
						<span className="fs-8">{i18n.resetAllFilters}</span>
					</button>
				)}
			</div>
			<div className="calian-career-dashboard-filter__mobile d-lg-none">
				<div className="calian-accordion accordion accordion-flush">
					<div className="accordion-item bg-transparent">
						<h2
							className="accordion-header"
							id="accordion-header-mobile"
						>
							<button
								className="accordion-button collapsed ms-1 p-2 fs-18px fw-normal"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#calian-career-dashboard-filter__accordion-mobile"
								aria-expanded="false"
								aria-controls="calian-career-dashboard-filter__accordion-mobile"
							>
								{i18n.heading}
							</button>
						</h2>
						<div
							id="calian-career-dashboard-filter__accordion-mobile"
							className="accordion-collapse collapse"
							aria-labelledby="accordion-header-mobile"
							data-bs-parent=".calian-career-dashboard-filter__desktop"
						>
							<div className="accordion-body p-0">
								{i18n.filters.map((filter, index) => {
									return (
										<div
											className="accordion-item bg-transparent"
											key={filter.taxonomy}
										>
											<h2 className="accordion-header">
												<button
													className="accordion-button collapsed bg-transparent ms-1 p-2 fw-normal"
													type="button"
													data-bs-toggle="collapse"
													data-bs-target={`#collapse${index}`}
													aria-expanded="false"
													aria-controls={`collapse${index}`}
												>
													{filter.tooltip && (
														<span
															className="d-inline-flex justify-content-start align-items-center"
															data-bs-toggle="tooltip"
															data-bs-custom-class="calian-career-dashboard-filter__tooltip"
															data-bs-placement="top"
															data-bs-title={
																filter.tooltip
															}
														>
															{filter.label}
															<i className="icon icon-question btn d-inline-flex justify-content-center align-items-center fs-8 ms-1 p-0"></i>
														</span>
													)}
												</button>
											</h2>
											<div
												id={`collapse${index}`}
												className="accordion-collapse collapse"
												aria-labelledby={`heading${index}`}
												data-bs-parent="#calian-career-dashboard-filter__accordion-mobile"
											>
												<div className="accordion-body ms-1 px-2 py-1">
													{(filter.options || []).map(
														(option) => {
															return (
																<div
																	key={
																		option.value
																	}
																	className="form-check"
																>
																	<input
																		className="form-check-input"
																		id={`filter-option-${option.value}-accordion-checkbox`}
																		type="checkbox"
																		name={`${filter.taxonomy}[]`}
																		value={
																			option.value
																		}
																		checked={
																			(
																				state[
																					filter
																						.taxonomy
																				] ||
																				[]
																			).indexOf(
																				option.value,
																			) !==
																			-1
																		}
																		onChange={
																			onChange
																		}
																	/>
																	<label
																		className="form-check-label fs-7"
																		htmlFor={`filter-option-${option.value}-accordion-checkbox`}
																	>
																		{
																			option.label
																		}
																	</label>
																</div>
															);
														},
													)}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>

				{Object.entries(state).length > 0 && (
					<button
						className="btn btn-sm link-accent-3 d-flex justify-content-center align-items-center   mt-3 ms-1 p-0 ps-2 fw-normal ls-0"
						onClick={onClear}
					>
						<i className="icon icon-close fs-8px me-2"></i>{' '}
						<span className="fs-8">{i18n.resetAllFilters}</span>
					</button>
				)}
			</div>
		</div>
	);
};

export default DashboardFilters;
